/* ============================================
   Bridal landing page scripts
   Consolidated from inline <script> blocks.
   FAQ JSON-LD remains inline in the section file.
   ============================================ */

/* --- Ring styles: tab switching --- */
(function() {
  var tabs = document.querySelectorAll('[data-rs-tab]');
  var panels = document.querySelectorAll('.ring-styles__panel');
  tabs.forEach(function(tab) {
    tab.addEventListener('click', function() {
      var target = tab.getAttribute('data-rs-tab');
      tabs.forEach(function(t) {
        t.classList.remove('is-active');
        t.setAttribute('aria-selected', 'false');
      });
      panels.forEach(function(p) {
        p.classList.remove('is-active');
      });
      tab.classList.add('is-active');
      tab.setAttribute('aria-selected', 'true');
      document.getElementById('rs-panel-' + target).classList.add('is-active');
    });
  });
})();

/* --- The Experience: video controls + step syncing --- */
(function() {
  var section = document.querySelector('.the-experience');
  if (!section) return;

  var steps = section.querySelectorAll('.te-step');
  var videoWrap = section.querySelector('.te-video');
  var video = section.querySelector('.te-video__media');
  var overlay = section.querySelector('.te-video__overlay');
  var pauseBtn = section.querySelector('.te-video__pause');
  var muteBtn = section.querySelector('.te-video__mute');
  var progressBar = section.querySelector('.te-video__progress-bar');

  // ---- Step switching ----
  function setStep(stepNum, opts) {
    opts = opts || {};
    steps.forEach(function(s) {
      var isActive = parseInt(s.getAttribute('data-step'), 10) === stepNum;
      s.classList.toggle('is-active', isActive);
      s.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });

    if (opts.seekVideo && video && video.readyState >= 1) {
      var t = parseFloat(steps[stepNum - 1].getAttribute('data-time')) || 0;
      try { video.currentTime = t; } catch (e) {}
    }
  }

  steps.forEach(function(step) {
    step.addEventListener('click', function() {
      var n = parseInt(step.getAttribute('data-step'), 10);
      setStep(n, { seekVideo: true });
    });
  });

  // ---- Video: custom overlay & controls ----
  if (video && overlay) {
    overlay.addEventListener('click', function() {
      videoWrap.setAttribute('data-state', 'playing');
      video.play();
    });

    video.addEventListener('play', function() {
      videoWrap.setAttribute('data-state', 'playing');
    });

    video.addEventListener('pause', function() {
      if (!video.ended) videoWrap.setAttribute('data-state', 'paused');
    });

    video.addEventListener('ended', function() {
      videoWrap.setAttribute('data-state', 'idle');
      try { video.currentTime = 0; } catch (e) {}
    });

    // Sync active step with video time
    video.addEventListener('timeupdate', function() {
      var t = video.currentTime;
      var active = 1;
      if (t >= 33) active = 3;
      else if (t >= 20) active = 2;
      var current = section.querySelector('.te-step.is-active');
      var currentNum = current ? parseInt(current.getAttribute('data-step'), 10) : 1;
      if (currentNum !== active) setStep(active);

      if (progressBar && video.duration) {
        progressBar.style.width = (t / video.duration * 100) + '%';
      }
    });

    if (pauseBtn) {
      pauseBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        if (video.paused) video.play(); else video.pause();
      });
    }

    if (muteBtn) {
      muteBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        video.muted = !video.muted;
        videoWrap.classList.toggle('is-muted', video.muted);
      });
    }

    // Click on progress bar to seek
    var progressTrack = section.querySelector('.te-video__progress');
    if (progressTrack) {
      progressTrack.addEventListener('click', function(e) {
        e.stopPropagation();
        if (!video.duration) return;
        var rect = progressTrack.getBoundingClientRect();
        var pct = (e.clientX - rect.left) / rect.width;
        pct = Math.max(0, Math.min(1, pct));
        try { video.currentTime = pct * video.duration; } catch (err) {}
      });
    }

    // Click on video itself toggles play/pause
    video.addEventListener('click', function() {
      if (video.paused) video.play(); else video.pause();
    });
  }
})();


(function() {
  var sections = document.querySelectorAll('.why-skeies');
  if (!sections.length) return;

  sections.forEach(function(section) {

    // ===== FAQ ACCORDION =====
    var faqItems = section.querySelectorAll('.ws-faq__item');
    faqItems.forEach(function(item) {
      var trigger = item.querySelector('.ws-faq__trigger');
      trigger.addEventListener('click', function() {
        var isOpen = item.classList.contains('is-open');
        // Only close siblings within the same section, not across sections.
        faqItems.forEach(function(i) {
          i.classList.remove('is-open');
          i.querySelector('.ws-faq__trigger').setAttribute('aria-expanded', 'false');
        });
        if (!isOpen) {
          item.classList.add('is-open');
          trigger.setAttribute('aria-expanded', 'true');
        }
      });
    });

    // ===== FADE IN ON SCROLL =====
    if ('IntersectionObserver' in window) {
      var fadeEls = section.querySelectorAll('.ws-promise, .ws-heritage, .ws-trio__item');
      fadeEls.forEach(function(el, i) {
        el.classList.add('ws-fade-in');
        el.style.transitionDelay = (i * 60) + 'ms';
      });
      var fadeObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            fadeObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -80px 0px' });
      fadeEls.forEach(function(el) { fadeObserver.observe(el); });
    }

  });
})();